// We need jQuery
var $ = window.jQuery;

// Import Cookies
import Cookies from 'js-cookie';

// Import stickyfill
var Stickyfill = require('stickyfill-web-module')();
var SimpleLightbox = require('simple-lightbox');

// Headroom
import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;

// Headroom jQuery
import 'headroom.js/dist/jQuery.headroom.js';

export default {
  init() {
    // JavaScript to be fired on all pages

		$('#footerbar_menu a').hover(function (event) {
			if ($("footer").hasClass('footer_open')) {
				$("#footerbar_menu a").addClass('hasfocus');
			} else {
				$("#footerbar_menu a").removeClass('hasfocus');
				$("#footerbar_menu a").removeClass('notfocus');
			}
		});

		$('#footerbar_menu').click(function (e) {
			e.preventDefault();
			if ($("footer").hasClass('footer_open')) {
				$("#footerbar_menu a").removeClass('hasfocus'); 
				$("#footerbar_menu a").addClass('notfocus'); 
			} else {
				$("#footerbar_menu a").addClass('hasfocus'); 
			}
			$("footer").toggleClass("footer_open");


		});
		
		$('#footerbar_top a').click(function (event) {
			event.preventDefault();
			var aid = $(this).attr("href");
			if ($("footer").hasClass('footer_open')) {
				$("#footerbar_menu a").removeClass('hasfocus');
				$("#footerbar_menu a").addClass('notfocus');
				$("footer").removeClass("footer_open");
			}
			$("html, body").animate({ scrollTop: 0 }, 1);
		});

		$('#footerbar_top a').hover(function(event) {
			$("#footerbar_menu a").removeClass('hasfocus');
			$("#footerbar_menu a").addClass('notfocus');
		}, function () {
			if ($("footer").hasClass('footer_open')) {
				$("#footerbar_menu a").addClass('hasfocus');
			};
			$("#footerbar_menu a").removeClass('notfocus');
		});

		// Headroom JS
		var options = {
			offset: 140,
			tolerance: 4
		};
		$("body.headroom").headroom(options);

		
		$('.wp-block-gallery figure a').simpleLightbox();



    // List for notication close
    $('#tofino-notification .close').on('click', function () {
      if (tofinoJS.cookieExpires) {
        Cookies.set('tofino-notification-closed', 'yes', { expires: parseInt(tofinoJS.cookieExpires) });
      } else {
        Cookies.set('tofino-notification-closed', 'yes');
      }
    });

    // Show the notfication using JS based on the cookie (fixes html caching issue)
    if (tofinoJS.notificationJS === 'true' && !Cookies.get('tofino-notification-closed')) {
      $('#tofino-notification').show();
    }

    // Assign sticky
    var $sticky = document.getElementsByClassName('sticky-top');
    if ($sticky.length) {
      Stickyfill.add($sticky[0]);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  loaded() {
    // Javascript to be fired on page once fully loaded
  }
};
